import { useTranslation } from 'next-i18next'

import SecondaryLanguage from '~/components/PanelSettingsForm/Language/components/SecondaryLanguage'

import DropdownMenu from '~/components/DropdownMenu/DropdownMenu'
import useSettingsFormContext from '~/hooks/useSettingsFormContext'
import { FieldError } from '~/components/FieldError'

import PrimaryLanguage from '~/components/PanelSettingsForm/Language/components/PrimaryLanguage'

export default function Language(): React.ReactElement {
  const { t } = useTranslation(['booking', 'studentPanel'])
  const { fields, errors } = useSettingsFormContext()

  const selectedStateLabel = [fields.languagePrimary, fields.languageSecondary]
    .map((elem) => (elem ? t(`booking:languages.${elem}` as const) : undefined))
    .filter(Boolean)
    .join(', ')

  return (
    <div>
      <DropdownMenu header={t('studentPanel:settings.labelLanguages')} selectedStateLabel={selectedStateLabel}>
        <div className="space-y-4">
          <PrimaryLanguage />
          <SecondaryLanguage />
        </div>
      </DropdownMenu>
      <FieldError error={errors.languagePrimary} />
    </div>
  )
}
